import React from "react";
import { useTranslation } from "../i18n/TranslationProvider";

import FeelingGood from "../images/feeling-good3.svg";
import FeelingNeutral from "../images/feeling-neutral3.svg";
import FeelingBad from "../images/feeling-bad3.svg";

const FeelingBar = ({ data, userName, splitView }) => {
    const { t } = useTranslation();
    const feelingData = data?.filter((obj) => obj.symptom_id == 53);
    const result = [
        { name: "Sad", value: 0 },
        { name: "Neutral", value: 0 },
        { name: "Happy", value: 0 },
    ];

    feelingData.forEach((item) => {
        switch (item.severity) {
            case 10:
                result[0].value++;
                break;
            case 50:
                result[1].value++;
                break;
            case 100:
                result[2].value++;
                break;
        }
    });

    const total = feelingData && feelingData.length ? feelingData.length : 0;
    result.forEach((item) => {
        item.value =
            total > 0 ? ((item.value / total) * 100).toFixed(1) : "0.0";
    });

    const itemStyle = {
        flex: 1,
        margin: "0 0.5rem",
        padding: "0.5rem",
        fontSize: "1.5rem",
        borderRadius: "5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
    const fontStyle = {
        color: "white",
        textAlign: "center",
        paddingLeft: "1.5rem",
        fontSize: "1.2rem",
    };
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "1rem",
                width: "100%",
                flexWrap: "wrap",
            }}
        >
            {/* Left column: title + optional note */}
            <div
                style={{
                    minWidth: 220,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <h3
                    style={{ fontSize: "1.2rem", fontStyle: "bold", margin: 0 }}
                >
                    {t("dashboard.overallFeelings")}
                    {splitView ? <span>{` (${userName})`}</span> : ""}
                </h3>
                {(!feelingData || feelingData.length === 0) && (
                    <h5
                        style={{ color: "grey", marginTop: 4, marginBottom: 0 }}
                    >
                        {t("dashboard.noTrackingData.0")}
                    </h5>
                )}
            </div>

            {/* Right column: three faces in one row */}
            <div
                style={{
                    display: "flex",
                    flex: "1 1 auto",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    alignItems: "stretch",
                }}
            >
                <div
                    className="d-flex align-items-center"
                    style={{ ...itemStyle, backgroundColor: "#2a6796" }}
                >
                    <img
                        src={FeelingBad}
                        alt={t("dashboard.ui.faceBad")}
                        style={{ width: 40, height: 40 }}
                    />
                    <span style={fontStyle}>{result[0].value}%</span>
                </div>
                <div
                    className="d-flex align-items-center"
                    style={{ ...itemStyle, backgroundColor: "#31366b" }}
                >
                    <img
                        src={FeelingNeutral}
                        alt={t("dashboard.ui.faceNeutral")}
                        style={{ width: 40, height: 40 }}
                    />
                    <span style={fontStyle}>{result[1].value}%</span>
                </div>
                <div
                    className="d-flex align-items-center"
                    style={{ ...itemStyle, backgroundColor: "#6c5082" }}
                >
                    <img
                        src={FeelingGood}
                        alt={t("dashboard.ui.faceHappy")}
                        style={{ width: 40, height: 40 }}
                    />
                    <span style={fontStyle}>{result[2].value}% </span>
                </div>
            </div>
        </div>
    );
};
export default FeelingBar;